export enum CollectionFilterOperator {
  In = 'IN',
  CaseInsensitiveLike = 'ILIKE',
  Like = 'LIKE',
  Equal = 'EQUAL',
  DateRange = 'DATE_RANGE',
  StartsWith = 'STARTS_WITH',
}
